// @mui
import { styled, alpha } from '@mui/material/styles';
import ListItemButton from '@mui/material/ListItemButton';

// ----------------------------------------------------------------------

export const ListItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active, theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.common.white,
  height: 48,
  // Active
  ...(active && {
    color: theme.palette.common.white,
    ...theme.typography.subtitle2,
    backgroundColor: alpha(theme.palette.common.white, theme.palette.action.selectedOpacity),
  }),
}));
